import { render, staticRenderFns } from "./OthersRed.vue?vue&type=template&id=380eaf82&scoped=true&"
import script from "./OthersRed.vue?vue&type=script&lang=js&"
export * from "./OthersRed.vue?vue&type=script&lang=js&"
import style0 from "./OthersRed.vue?vue&type=style&index=0&id=380eaf82&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380eaf82",
  null
  
)

export default component.exports